"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OleShakyStickAbilityHandler = exports.OleShakyStickActorAbilityFactory = exports.OleShakyStickAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class OleShakyStickAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.OleShakyStick;
        this.__typeName = "OleShakyStick";
    }
}
exports.OleShakyStickAbilityArgs = OleShakyStickAbilityArgs;
let OleShakyStickActorAbilityFactory = class OleShakyStickActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("OleShakyStick", "OneAllies", 1);
    }
};
OleShakyStickActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("OleShakyStick")
], OleShakyStickActorAbilityFactory);
exports.OleShakyStickActorAbilityFactory = OleShakyStickActorAbilityFactory;
let OleShakyStickAbilityHandler = class OleShakyStickAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "chest"), "WeirdPurpleAndGreen"));
                for (const effect of container.getHarmfulEffects(selectedAlly)) {
                    container.cancelEffect(sequence, effect.id);
                }
            }
        });
    }
};
OleShakyStickAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.OleShakyStick)
], OleShakyStickAbilityHandler);
exports.OleShakyStickAbilityHandler = OleShakyStickAbilityHandler;
